import { apiClient } from './client';

export const faucetApi = {
  status: () =>
    apiClient.get<{ canClaim: boolean; amount: string; nextAt: string }>('/faucet/status').then((r) => r.data),
  claim: () =>
    apiClient.post<{ claimed: string; newBalance: string; nextAt: string }>('/faucet/claim').then((r) => r.data),
};
